// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/pages/ReceiptWorkbenchPage.js
// =============================================================================

import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import {
  useParams
} from "react-router-dom";

import {

  receiveShipment,
  getReceiptDetail,
  saveReceiptVerification,
  submitReceipt,
  saveBoxVerification,
  confirmBoxVerification

} from "../services/materialReceiptService";


// =============================================================================
// COMPONENT
// =============================================================================

export default function ReceiptWorkbenchPage() {

  // ===========================================================================
  // PARAMS
  // ===========================================================================
  const {
    receiptId
  } = useParams();


  // ===========================================================================
  // STATE
  // ===========================================================================
  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const [detail, setDetail] =
    useState(null);

  const [remarks, setRemarks] =
    useState("");

  const [lines, setLines] =
    useState([]);

  const [actionLoading, setActionLoading] =
    useState(false);
  const [

  boxVerification,

  setBoxVerification

] = useState({

  dispatched_box_count: 0,

  received_box_count: 0,

  damaged_box_count: 0,

  short_box_count: 0
});

  // ===========================================================================
  // LOAD DETAIL
  // ===========================================================================
  const loadDetail = async () => {

    try {

      setLoading(true);

      setError("");

      const response =
        await getReceiptDetail(
          receiptId
        );

      if (response?.success) {

        const data =
          response.data;

        setDetail(data);

        setRemarks(
          data?.header?.remarks || ""
        );

        setLines(

          (data?.lines || []).map((line) => ({

            ...line,

            received_qty:
              line.received_qty || 0,

            damaged_qty:
              line.damaged_qty || 0,

            remarks:
              line.remarks || ""
          }))
        );
        setBoxVerification({

  dispatched_box_count:

    data?.header?.dispatched_box_count || 0,

  received_box_count:

    data?.header?.received_box_count || 0,

  damaged_box_count:

    data?.header?.damaged_box_count || 0,

  short_box_count:

    data?.header?.short_box_count || 0
});

      } else {

        setError(
          "Failed to load receipt detail"
        );
      }

    } catch (err) {

      console.error(err);

      setError(
        "Failed to load receipt detail"
      );

    } finally {

      setLoading(false);
    }
  };


  // ===========================================================================
  // RECEIVE SHIPMENT
  // ===========================================================================
  const handleReceiveShipment =
    async () => {

      try {

        const confirmed =
          window.confirm(

            "Confirm shipment received?"
          );

        if (!confirmed) {

          return;
        }

        setActionLoading(true);

        await receiveShipment(
          receiptId
        );

        alert(
          "Shipment received successfully"
        );

        loadDetail();

      } catch (err) {

        console.error(err);

        alert(

          err?.response?.data?.message ||

          "Failed to receive shipment"
        );

      } finally {

        setActionLoading(false);
      }
    };


  // ===========================================================================
// SAVE BOX VERIFICATION
// ===========================================================================
const handleSaveBoxVerification =
  async () => {

    try {

      setActionLoading(true);

      await saveBoxVerification(

        receiptId,

        {

          dispatched_box_count:

            Number(
              boxVerification
              .dispatched_box_count || 0
            ),

          received_box_count:

            Number(
              boxVerification
              .received_box_count || 0
            ),

          damaged_box_count:

            Number(
              boxVerification
              .damaged_box_count || 0
            ),

          remarks
        }
      );

      alert(
        "Box verification saved successfully"
      );

      loadDetail();

    } catch (err) {

      console.error(err);

      alert(

        err?.response?.data?.message ||

        "Failed to save box verification"
      );

    } finally {

      setActionLoading(false);
    }
  };

  // ===========================================================================
// CONFIRM BOX VERIFICATION
// ===========================================================================
const handleConfirmBoxVerification =
  async () => {

    try {

      const confirmed =
        window.confirm(

          "Confirm box verification?"
        );

      if (!confirmed) {

        return;
      }

      setActionLoading(true);

      await confirmBoxVerification(
        receiptId
      );

      alert(
        "Box verification confirmed successfully"
      );

      loadDetail();

    } catch (err) {

      console.error(err);

      alert(

        err?.response?.data?.message ||

        "Failed to confirm box verification"
      );

    } finally {

      setActionLoading(false);
    }
  };
    // ===========================================================================
  
  // SAVE VERIFICATION
  // ===========================================================================
  const handleSaveVerification =
    async () => {

      try {

        setActionLoading(true);

        await saveReceiptVerification(

          receiptId,

          {

            remarks,

            lines: lines.map((line) => ({

              id: line.id,

              received_qty:
                Number(
                  line.received_qty || 0
                ),

              damaged_qty:
                Number(
                  line.damaged_qty || 0
                ),

              remarks:
                line.remarks || ""
            }))
          }
        );

        alert(
          "Verification saved successfully"
        );

        loadDetail();

      } catch (err) {

        console.error(err);

        alert(

          err?.response?.data?.message ||

          "Failed to save verification"
        );

      } finally {

        setActionLoading(false);
      }
    };


  // ===========================================================================
  // SUBMIT RECEIPT
  // ===========================================================================
  const handleSubmitReceipt =
    async () => {

      try {

        const confirmed =
          window.confirm(

            "Submit receipt for reconciliation?"
          );

        if (!confirmed) {

          return;
        }

        setActionLoading(true);

        await submitReceipt(
          receiptId
        );

        alert(
          "Receipt submitted successfully"
        );

        loadDetail();

      } catch (err) {

        console.error(err);

        alert(

          err?.response?.data?.message ||

          "Failed to submit receipt"
        );

      } finally {

        setActionLoading(false);
      }
    };


  // ===========================================================================
  // UPDATE LINE
  // ===========================================================================
  const updateLine = (
    index,
    field,
    value
  ) => {

    const updated =
      [...lines];

    updated[index][field] =
      value;

    setLines(updated);
  };


  // ===========================================================================
  // INITIAL LOAD
  // ===========================================================================
  useEffect(() => {

    loadDetail();

  }, [receiptId]);


  const totals =
    useMemo(() => {

      return lines.reduce(

        (acc, line) => {

          acc.dispatch_qty +=
            Number(
              line.dispatch_qty || 0
            );

          acc.received_qty +=
            Number(
              line.received_qty || 0
            );

          acc.damaged_qty +=
            Number(
              line.damaged_qty || 0
            );

          return acc;

        },

        {

          dispatch_qty: 0,

          received_qty: 0,

          damaged_qty: 0
        }
      );

    }, [lines]);

  
  // ===========================================================================
  // LOADING
  // ===========================================================================
  if (loading) {

    return (

      <div style={styles.loader}>

        Loading receipt detail...

      </div>
    );
  }


  // ===========================================================================
  // ERROR
  // ===========================================================================
  if (error) {

    return (

      <div style={styles.errorBox}>

        {error}

      </div>
    );
  }


  // ===========================================================================
  // HEADER
  // ===========================================================================
  const header =
    detail?.header || {};


  // ===========================================================================
  // SUMMARY
  // ===========================================================================
  

  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <div style={styles.page}>


      {/* ================================================================ */}
      {/* HEADER */}
      {/* ================================================================ */}
      <div style={styles.headerCard}>


        <div>

          <div style={styles.title}>

            {

              header.receipt_no ||

              "Receipt Workbench"
            }

          </div>

          <div style={styles.subTitle}>

            Project:
            {" "}

            {

              header.project_name ||

              "-"
            }

          </div>

        </div>


        <div style={styles.headerRight}>


          <span style={
            getStatusStyle(
              header.receipt_status
            )
          }>

            {

              header.receipt_status ||

              "DRAFT"
            }

          </span>


          {

            header.receipt_status ===
            "DRAFT" && (

              <button
                style={styles.receiveBtn}
                onClick={
                  handleReceiveShipment
                }
                disabled={actionLoading}
              >

                Receive Shipment

              </button>
            )
          }


          {

            [
              "RECEIVED",
              "BOX_VERIFIED"
            ].includes(
              header.receipt_status
            ) && (

              <>

                <button
                  style={styles.saveBtn}
                  onClick={
                    handleSaveVerification
                  }
                  disabled={actionLoading}
                >

                  Save Verification

                </button>


                <button
                  style={styles.submitBtn}
                  onClick={
                    handleSubmitReceipt
                  }
                  disabled={actionLoading}
                >

                  Submit Receipt

                </button>

              </>
            )
          }

        </div>

      </div>


      {/* ================================================================ */}
      {/* SUMMARY */}
      {/* ================================================================ */}
      <div style={styles.sectionCard}>


        <div style={styles.sectionTitle}>
          Receipt Summary
        </div>


        <div style={styles.summaryGrid}>


          <SummaryItem
            label="Dispatch No"
            value={
              header.dispatch_no
            }
          />

          <SummaryItem
            label="Site Store"
            value={
              header.site_store_name
            }
          />

          <SummaryItem
            label="Receipt Date"
            value={
              header.receipt_date
            }
          />

          <SummaryItem
            label="Receipt Status"
            value={
              header.receipt_status
            }
          />

          <SummaryItem
            label="Total Dispatch Qty"
            value={
              totals.dispatch_qty
            }
          />

          <SummaryItem
            label="Total Received Qty"
            value={
              totals.received_qty
            }
          />

        </div>

      </div>


      {/* ================================================================ */}
      {/* WORKFLOW */}
      {/* ================================================================ */}
      <div style={styles.sectionCard}>


        <div style={styles.sectionTitle}>
          Workflow Status
        </div>


        <div style={styles.workflowBar}>


          {

            workflowSteps.map((step) => {

              const active =
                step ===
                header.receipt_status;

              return (

                <div
                  key={step}
                  style={
                    active
                      ? styles.activeStep
                      : styles.step
                  }
                >

                  {step}

                </div>
              );
            })
          }

        </div>

      </div>


            {/* ================================================================ */}
      {/* BOX VERIFICATION */}
      {/* ================================================================ */}
      <div style={styles.sectionCard}>


        <div style={styles.sectionTitle}>

          Box Verification

        </div>


        <div style={styles.boxGrid}>


          {/* ========================================================== */}
          {/* DISPATCHED */}
          {/* ========================================================== */}
          <div style={styles.summaryItem}>

            <div style={styles.summaryLabel}>
              Dispatched Boxes
            </div>

            <input

              type="number"

              value={
                boxVerification
                .dispatched_box_count
              }

              onChange={(e) =>

                setBoxVerification({

                  ...boxVerification,

                  dispatched_box_count:
                    e.target.value,

                  short_box_count:

                    Number(
                      e.target.value || 0
                    )

                    -

                    Number(
                      boxVerification
                      .received_box_count || 0
                    )
                })
              }

              style={styles.input}

              disabled={
                header.receipt_status ===
                "BOX_VERIFIED"

                ||

                header.receipt_status ===
                "SUBMITTED"

                ||

                header.receipt_status ===
                "RECONCILED"
              }
            />

          </div>


          {/* ========================================================== */}
          {/* RECEIVED */}
          {/* ========================================================== */}
          <div style={styles.summaryItem}>

            <div style={styles.summaryLabel}>
              Received Boxes
            </div>

            <input

              type="number"

              value={
                boxVerification
                .received_box_count
              }

              onChange={(e) => {

                const received =
                  Number(
                    e.target.value || 0
                  );

                setBoxVerification({

                  ...boxVerification,

                  received_box_count:
                    received,

                  short_box_count:

                    Number(
                      boxVerification
                      .dispatched_box_count || 0
                    )

                    -

                    received
                });
              }}

              style={styles.input}

              disabled={
                header.receipt_status ===
                "BOX_VERIFIED"

                ||

                header.receipt_status ===
                "SUBMITTED"

                ||

                header.receipt_status ===
                "RECONCILED"
              }
            />

          </div>


          {/* ========================================================== */}
          {/* DAMAGED */}
          {/* ========================================================== */}
          <div style={styles.summaryItem}>

            <div style={styles.summaryLabel}>
              Damaged Boxes
            </div>

            <input

              type="number"

              value={
                boxVerification
                .damaged_box_count
              }

              onChange={(e) =>

                setBoxVerification({

                  ...boxVerification,

                  damaged_box_count:
                    e.target.value
                })
              }

              style={styles.input}

              disabled={
                header.receipt_status ===
                "BOX_VERIFIED"

                ||

                header.receipt_status ===
                "SUBMITTED"

                ||

                header.receipt_status ===
                "RECONCILED"
              }
            />

          </div>


          {/* ========================================================== */}
          {/* SHORT */}
          {/* ========================================================== */}
          <div style={styles.summaryItem}>

            <div style={styles.summaryLabel}>
              Short Boxes
            </div>

            <div style={styles.summaryValue}>

              {

                boxVerification
                .short_box_count || 0
              }

            </div>

          </div>

        </div>


        {/* ============================================================ */}
        {/* ACTIONS */}
        {/* ============================================================ */}
        {

          ![
            "BOX_VERIFIED",
            "SUBMITTED",
            "RECONCILED"
          ].includes(
            header.receipt_status
          ) && (

            <div style={styles.boxActionBar}>


              <button

                style={styles.saveBtn}

                onClick={
                  handleSaveBoxVerification
                }

                disabled={actionLoading}
              >

                Save Box Verification

              </button>


              <button

                style={styles.confirmBoxBtn}

                onClick={
                  handleConfirmBoxVerification
                }

                disabled={actionLoading}
              >

                Confirm Box Verification

              </button>

            </div>
          )
        }

      </div>
      
      {/* ================================================================ */}
      {/* MATERIAL VERIFICATION */}
      {/* ================================================================ */}
      <div style={styles.sectionCard}>


        <div style={styles.sectionTitle}>

          Material Verification
          {" "}
          ({lines.length})

        </div>


        <div style={styles.lineTable}>


          {/* ============================================================ */}
          {/* TABLE HEADER */}
          {/* ============================================================ */}
          <div style={styles.tableHeader}>


            <div style={styles.colMaterial}>
              Material
            </div>

            <div style={styles.colQty}>
              Dispatch
            </div>

            <div style={styles.colQty}>
              Received
            </div>

            <div style={styles.colQty}>
              Damaged
            </div>

            <div style={styles.colRemarks}>
              Remarks
            </div>

          </div>


          {/* ============================================================ */}
          {/* ROWS */}
          {/* ============================================================ */}
          {

            lines.map((line, index) => (

              <div
                key={line.id}
                style={styles.lineRow}
              >


                <div style={styles.colMaterial}>


                  <div style={styles.materialName}>

                    {

                      line.material_name ||

                      line.material_description
                    }

                  </div>


                  <div style={styles.materialSub}>

                    Code:
                    {" "}

                    {

                      line.material_code || "-"
                    }

                  </div>

                </div>


                <div style={styles.colQty}>

                  {line.dispatch_qty}

                </div>


                <div style={styles.colQty}>


                  <input

                    type="number"

                    value={
                      line.received_qty
                    }

                    onChange={(e) =>

                      updateLine(

                        index,

                        "received_qty",

                        e.target.value
                      )
                    }

                    style={styles.input}

                    disabled={
                      header.receipt_status ===
                      "SUBMITTED"
                    }
                  />

                </div>


                <div style={styles.colQty}>


                  <input

                    type="number"

                    value={
                      line.damaged_qty
                    }

                    onChange={(e) =>

                      updateLine(

                        index,

                        "damaged_qty",

                        e.target.value
                      )
                    }

                    style={styles.input}

                    disabled={
                      header.receipt_status ===
                      "SUBMITTED"
                    }
                  />

                </div>


                <div style={styles.colRemarks}>


                  <input

                    type="text"

                    value={
                      line.remarks
                    }

                    onChange={(e) =>

                      updateLine(

                        index,

                        "remarks",

                        e.target.value
                      )
                    }

                    style={styles.input}

                    disabled={
                      header.receipt_status ===
                      "SUBMITTED"
                    }
                  />

                </div>

              </div>
            ))
          }

        </div>

      </div>


      {/* ================================================================ */}
      {/* REMARKS */}
      {/* ================================================================ */}
      <div style={styles.sectionCard}>


        <div style={styles.sectionTitle}>
          Receipt Remarks
        </div>


        <textarea

          value={remarks}

          onChange={(e) =>
            setRemarks(e.target.value)
          }

          style={styles.textArea}

          disabled={
            header.receipt_status ===
            "SUBMITTED"
          }
        />

      </div>

    </div>
  );
}


// =============================================================================
// SUMMARY ITEM
// =============================================================================

function SummaryItem({

  label,

  value

}) {

  return (

    <div style={styles.summaryItem}>

      <div style={styles.summaryLabel}>
        {label}
      </div>

      <div style={styles.summaryValue}>
        {value || "-"}
      </div>

    </div>
  );
}


// =============================================================================
// WORKFLOW
// =============================================================================

const workflowSteps = [

  "DRAFT",

  "RECEIVED",

  "BOX_VERIFIED",

  "SUBMITTED",

  "RECONCILED"
];


// =============================================================================
// STATUS STYLE
// =============================================================================

function getStatusStyle(status) {

  switch (status) {

    case "RECONCILED":

      return styles.statusGreen;

    case "SUBMITTED":

      return styles.statusOrange;

    case "RECEIVED":

      return styles.statusBlue;

    default:

      return styles.statusGray;
  }
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  page: {

    padding: 20,

    background: "#f5f7fb",

    minHeight: "100vh"
  },

  loader: {

    padding: 40,

    textAlign: "center"
  },

  errorBox: {

    margin: 20,

    padding: 20,

    background: "#fee2e2",

    color: "#b91c1c",

    borderRadius: 12
  },

  headerCard: {

    background:
      "linear-gradient(90deg, #2563eb, #3b82f6)",

    borderRadius: 14,

    padding: 20,

    marginBottom: 20,

    color: "#ffffff",

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center"
  },

  headerRight: {

    display: "flex",

    alignItems: "center",

    gap: 12
  },

  receiveBtn: {

    background: "#0891b2",

    color: "#fff",

    border: "none",

    borderRadius: 8,

    padding: "10px 16px",

    cursor: "pointer",

    fontWeight: 600
  },

  saveBtn: {

    background: "#111827",

    color: "#fff",

    border: "none",

    borderRadius: 8,

    padding: "10px 16px",

    cursor: "pointer",

    fontWeight: 600
  },

  submitBtn: {

    background: "#16a34a",

    color: "#fff",

    border: "none",

    borderRadius: 8,

    padding: "10px 16px",

    cursor: "pointer",

    fontWeight: 600
  },

  title: {

    fontSize: 24,

    fontWeight: 700
  },

  subTitle: {

    marginTop: 6,

    fontSize: 13,

    opacity: 0.9
  },

  sectionCard: {

    background: "#ffffff",

    borderRadius: 12,

    padding: 20,

    marginBottom: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  sectionTitle: {

    fontSize: 16,

    fontWeight: 700,

    color: "#111827",

    marginBottom: 16
  },

  summaryGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16
  },
  boxGrid: {

  display: "grid",

  gridTemplateColumns:
    "repeat(auto-fit, minmax(220px, 1fr))",

  gap: 16
},

boxActionBar: {

  marginTop: 20,

  display: "flex",

  gap: 12
},

confirmBoxBtn: {

  background: "#2563eb",

  color: "#fff",

  border: "none",

  borderRadius: 8,

  padding: "10px 16px",

  cursor: "pointer",

  fontWeight: 600
},

  summaryItem: {

    background: "#f9fafb",

    borderRadius: 10,

    padding: 14
  },

  summaryLabel: {

    fontSize: 12,

    color: "#6b7280",

    marginBottom: 6
  },

  summaryValue: {

    fontSize: 14,

    fontWeight: 600,

    color: "#111827"
  },

  workflowBar: {

    display: "flex",

    gap: 12,

    flexWrap: "wrap"
  },

  activeStep: {

    background: "#2563eb",

    color: "#ffffff",

    padding: "10px 16px",

    borderRadius: 30,

    fontSize: 12,

    fontWeight: 700
  },

  step: {

    background: "#e5e7eb",

    color: "#374151",

    padding: "10px 16px",

    borderRadius: 30,

    fontSize: 12,

    fontWeight: 700
  },

  lineTable: {

    display: "flex",

    flexDirection: "column",

    gap: 10
  },

  tableHeader: {

    display: "grid",

    gridTemplateColumns:
      "2.5fr 1fr 1fr 1fr 2fr",

    gap: 16,

    padding: "14px 16px",

    background: "#f9fafb",

    border:
      "1px solid #e5e7eb",

    borderRadius: 10,

    fontSize: 13,

    fontWeight: 700,

    color: "#374151"
  },

  lineRow: {

    display: "grid",

    gridTemplateColumns:
      "2.5fr 1fr 1fr 1fr 2fr",

    gap: 16,

    padding: "14px 16px",

    border:
      "1px solid #e5e7eb",

    borderRadius: 10,

    alignItems: "center",

    background: "#ffffff"
  },

  colMaterial: {

    display: "flex",

    flexDirection: "column"
  },

  colQty: {

    display: "flex",

    alignItems: "center",

    justifyContent: "center"
  },

  colRemarks: {

    display: "flex",

    alignItems: "center"
  },

  materialName: {

    fontWeight: 600,

    color: "#111827"
  },

  materialSub: {

    marginTop: 4,

    fontSize: 12,

    color: "#6b7280"
  },

  input: {

    width: "100%",

    border:
      "1px solid #d1d5db",

    borderRadius: 8,

    padding: "8px 10px"
  },

  textArea: {

    width: "100%",

    minHeight: 120,

    border:
      "1px solid #d1d5db",

    borderRadius: 10,

    padding: 14
  },

  statusGray: {

    background: "#f3f4f6",

    color: "#374151",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  },

  statusBlue: {

    background: "#dbeafe",

    color: "#1d4ed8",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  },

  statusOrange: {

    background: "#ffedd5",

    color: "#c2410c",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  },

  statusGreen: {

    background: "#dcfce7",

    color: "#15803d",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  }
};